module.exports = __webpack_public_path__ + "img/saibamais.4af8c205.jpg";